import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LanguageSwitcher from './LanguageSwitcher';
import './Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const guestLinks = [{ to: '/courses', label: 'All Courses' }];

  const learnerLinks = [
    { to: '/courses', label: 'All Courses' },
    { to: '/my-courses', label: 'My Courses' },
    { to: '/', label: 'Dashboard' },
    { to: '/certificates', label: 'Certificates' },
    { to: '/badges', label: 'Badges' },
    { to: '/leaderboard', label: 'Leaderboard' },
    { to: '/achievements', label: 'Achievements' },
    { to: '/goals', label: 'Goals' },
  ];

  const instructorLinks = [
    { to: '/my-courses', label: 'My Courses' },
    { to: '/create-course', label: 'Create Course' },
    { to: '/instructor', label: 'Instructor Console' },
  ];

  const adminLinks = [
    { to: '/admin', label: 'Admin Dashboard' },
    { to: '/analytics', label: 'Analytics' },
    { to: '/create-course', label: 'Manage Courses' },
    { to: '/instructor', label: 'Instructor Console' },
    { to: '/students', label: 'Students' },
    { to: '/certificates', label: 'Manage Certificates' },
  ];

  const getNavLinks = () => {
    if (!user) {
      return guestLinks;
    }

    if (user.role === 'admin') {
      return adminLinks;
    }

    if (user.role === 'instructor') {
      return instructorLinks;
    }

    return learnerLinks;
  };

  const navLinks = getNavLinks();

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <img 
            src="https://anu-kingdom.techbrio.io/wp-content/uploads/2025/10/image-19.png" 
            alt="Logo"
            style={{ width: "100px" }}
          />
        </Link>
        <ul className="nav-menu">
          {navLinks.map((link) => (
            <li key={link.to}>
              <Link to={link.to}>{link.label}</Link>
            </li>
          ))}
          {user ? (
            <>
              <li className="nav-dropdown">
                <span className="user-info dropdown-trigger">
                  {user.first_name} ({user.role})
                </span>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/profile">Profile</Link>
                  </li>
                  <li>
                    <Link to="/settings">Settings</Link>
                  </li>
                  <li>
                    <button onClick={handleLogout} className="btn-logout">
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            </>
          ) : (
            <>
              <li>
                <Link to="/login">Login</Link>
              </li>
              <li>
                <Link to="/register">Register</Link>
              </li>
            </>
          )}
          <li><LanguageSwitcher /></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
